export const TelemetryCustom = "/api/telemetry/trackEvent";

export type TelemetryActionType = "Undefined" | "View" | "Click" | "Swipe" | "Display";

export type TelemetryClickFromType =
    | "Undefined"
    | "Login"
    | "ForYou"
    | "SearchResult"
    | "DiscDetails"
    | "FlyerDetails"
    | "FlyerViewer"
    | "FlyerViewerSearch"
    | "FlyersWorld"
    | "Favorites"
    | "Brands"
    | "BrandDetails"
    | "SponsoredBrand"
    | "Malls"
    | "MallOffers"
    | "MallBrands"
    | "MallDetails"
    | "MallsAll"
    | "PredefMallFilter"
    | "SettingsProfile"
    | "SettingsForU"
    | "BrandsAll"
    | "SpecialEvent"
    | "BrandsNewOccasions"
    | "SavedMallOffers"
    | "SavedDiscounts"
    | "Map"
    | "Search"
    | "About"
    | "LtLandingPage"
    | "Ecommerce"
    | "GenericLandingPage"
    | "Homepage"
    | "usprfl-profile-newsletter";

export type ITelemetryCustom = {
    eventName: string;
    itemId?: string;
    param1?: string;
    param2?: string;
    param3?: string;
    param4?: string;
    actionType: TelemetryActionType;
    origin?: TelemetryClickFromType | string;
    channel?: "Plugin" | "Web" | "WebOnMobile";
};

let customTrackEventsList: ITelemetryCustom[] = [];
let telemetryTimeout: number | null = null;

export const sendTelemetryEvent = (telemetryData: ITelemetryCustom): void => {
    if (!telemetryData) return;

    if (telemetryData.origin && telemetryData.origin.length > 50) {
        telemetryData.origin = telemetryData.origin.substring(0, 50);
    }

    customTrackEventsList.push(telemetryData);

    if (telemetryTimeout === null) {
        telemetryTimeout = window.setTimeout(() => {
            const list = customTrackEventsList;
            customTrackEventsList = [];
            fetch(TelemetryCustom, {
                method: "POST",
                body: JSON.stringify(list),
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                mode: "cors",
            });
            customTrackEventsList = [];
            telemetryTimeout = null;
        });
    }
};

export const TelemetryEntity = {
    Discount: "Discount",
    Flyer: "Flyer",
    Brand: "Brand",
    FlyerDetails: "FlyerDetails",
    BrandDetails: "BrandDetails",
    Category: "Category",
    ShoppingMall: "ShoppingMall",
    SpecialMoment: "SpecialMoment",
    Search: "search",
    VideoBanner: "VideoBanner",
    LoyaltyProgram: "LoyaltyProgram",
    Cashback: "cshbck",
    Common: "common",
    NavigationBar: "btmbar",
    Settings: "usprfl",
    Homepage: "homepg",
    UserCommunication: "UserCommunication",
    Login: "login",
    Register: "rgstr",
    About: "About",
    Comparison: "prcomp",
};
